// @ts-nocheck
import cx from 'helpers/cx'

import Avatar from 'js/components/Avatar/Avatar'

import styles from './ChatAvatar.module.css'

type Props = {
    container: ChatContainer
    size?: AvatarSize
    className?: string
    style?: CSSProperties
}

const ChatAvatar = ({ container, size = 'small', className, style }: Props) => {
    const { type, entities } = container
    const isMultiple = entities.length > 1
    const isOnline = entities[0]?.isOnline

    const avatarProps = isMultiple
        ? { number: entities.length }
        : {
              image:
                  type === 'group'
                      ? entities[0]?.icon?.download
                      : entities[0]?.icon,
              name: entities[0]?.name,
              onlineStatus:
                  type === 'users'
                      ? isOnline === undefined
                          ? undefined
                          : isOnline
                            ? 'online'
                            : 'offline'
                      : null,
          }

    return (
        <div
            className={cx(
                styles.wrapper,
                isMultiple && styles.isMultiple,
                className,
            )}
            style={style}
        >
            <Avatar
                disabled
                size={size}
                radiusStyle={type === 'group' ? 'rounded' : 'round'}
                {...avatarProps}
            />
        </div>
    )
}

export default ChatAvatar
